import React from "react"
import PropTypes from "prop-types"
import styled, { css, keyframes } from "styled-components"

const barCSS = css`
  background: #f27270;
  border-radius: 3px;
  height: 22px;
  margin: 0 2px;
  width: 3px;
`

const Bar1 = styled.div`
  ${barCSS};
  background-color: #00adef;
  animation-delay: 0.1s;
`

const Bar2 = styled.div`
  ${barCSS};
  background-color: #fff100;
  animation-delay: 0.2s;
`

const Bar3 = styled.div`
  ${barCSS};
  background-color: #ec018b;
  animation-delay: 0.3s;
`

const Bar4 = styled.div`
  ${barCSS};
  background-color: #4d4d4d;
  animation-delay: 0.4s;
`

const Wrapper = styled.div`
  display: flex;
`

const Loading = () => (
  <Wrapper>
    <Bar1 className='slLoadingBar' />
    <Bar2 className='slLoadingBar' />
    <Bar3 className='slLoadingBar' />
    <Bar4 className='slLoadingBar' />
  </Wrapper>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/atoms/Loading/index.js